import { get, set, size } from 'global/lib/lodash';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { VendorList } from '../../admin/vendors';
import { FormControl, InputLabel, Select, MenuItem, Input } from '@mui/material';
import useStyles from 'global/styles/filters';
import { useScreen } from 'global/styles';
import setUserRealm from 'redux/actions/userRealm';
import setFilter from 'redux/actions/setFilter';
import { sortAlphaNum } from 'global/utils';

export default (props) => {
  const { vendors } = props;
  const filter = useSelector((state) => get(state, 'filter.users.manage'));
  const dispatch = useDispatch();

  const { isMobile } = useScreen();

  const classes = useStyles({ isMobile });

  const clientId = get(filter, 'client_id', 0);
  const show = clientId !== 0;

  const handleClientChange = (e) => {
    const val = e.target.value;
    const vend = vendors.data.find((v) => v.id === val);
    dispatch(setUserRealm(get(vend, 'client')));
    dispatch(setFilter('users', 'manage', set({ ...filter }, 'client_id', val)));
  };

  const getVendor = () => {
    const vendor = vendors.data.find((v) => v.id === clientId);
    return vendor && [vendor];
  };

  const vend = getVendor();

  const renderNameFilter = () => {
    return (
      <div style={{ width: 300, marginLeft: 40, marginBottom: show ? 0 : 16 }}>
        <div className={classes.flexFilters}>
          <FormControl variant="standard" className={classes.formItem}>
            <InputLabel htmlFor="Standard-scorecard-simple">Client</InputLabel>
            <Select value={get(filter, 'client_id')} onChange={handleClientChange} input={<Input name="scorecard" id="Standard-scorecard-simple" />}>
              <MenuItem value={0}>
                <em>None</em>
              </MenuItem>
              {vendors.data
                .sort((a, b) => sortAlphaNum(a, b, 'client.name'))
                .map((vendor) => {
                  return (
                    <MenuItem key={vendor.id} value={vendor.id}>
                      {get(vendor, 'client.name')}
                    </MenuItem>
                  );
                })}
            </Select>
          </FormControl>
        </div>
      </div>
    )
  }

  return !size(vendors.data) ? null : (
    <div style={{ marginLeft: -32 }}>
      {renderNameFilter()}
      {show && <VendorList data={vend} canEdit={false} hideBorders showName={false} />}
    </div>
  )
};
